import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = 'https://app.sesmailbox.com';

// Per-route SEO meta for the indexable app pages. Any path not listed here is
// treated as a private app page → noindex, generic title.
const PAGE_META = {
  '/login': {
    title:       'Sign in to SES Mailbox — AWS SES Email Dashboard',
    description: 'Log in to your SES Mailbox account to send campaigns, manage subscribers, and track deliverability on your own AWS SES.',
  },
  '/register': {
    title:       'Sign up free for SES Mailbox — AWS SES Email Marketing',
    description: 'Create a free SES Mailbox account and run email marketing on your own AWS SES — flat $9.99/mo, no per-contact pricing, no credit card.',
  },
};

const DEFAULT_TITLE = 'SES Mailbox';
const DEFAULT_DESC  = 'SES Mailbox — the dashboard for AWS SES. Send campaigns to thousands for cents, not dollars.';

/**
 * Manages per-route SEO meta for the app (a CRA SPA):
 *  - robots: index,follow on /login and /register; noindex,nofollow elsewhere
 *  - <title> and <meta name="description">: optimized per indexable page
 *  - <link rel="canonical">: added for indexable pages, removed otherwise
 */
export default function RobotsManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = PAGE_META[pathname];
    const isIndexable = !!page;

    // robots
    const robots = document.getElementById('robots-meta');
    if (robots) robots.setAttribute('content', isIndexable ? 'index,follow' : 'noindex,nofollow');

    // title + description
    document.title = page ? page.title : DEFAULT_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', page ? page.description : DEFAULT_DESC);

    // canonical — present only for indexable pages
    let canonical = document.querySelector('link[rel="canonical"]');
    if (isIndexable) {
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', BASE + pathname);
    } else if (canonical) {
      canonical.remove();
    }
  }, [pathname]);

  return null;
}
